import React, { Suspense } from 'react';
import { Link } from 'react-router-dom';
import { AuthCheckAdmin } from '../../../../Utils/AuthCheck/AdminCheck.auth';
import HelmetHelper from '../../../../Components/PageHelmet/HelmetHelper.component';
import { useParams } from 'react-router-dom';
import {
  CompanyHomeContainer,
  CompanyNav,
} from '../../Companies/CompaniesHome/CompanyHome.styles';
import UserData from './UserData.component';
import BreadCrumbs from '../../../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import UserDataAdminProvider from '../../../../Utils/Users/UserDataAdminProvider';

const UserAdminHome = () => {
  const { id } = useParams();
  return (
    <AuthCheckAdmin>
      <Suspense fallback={<p>Loading page...</p>}>
        <HelmetHelper
          title="User Homepage | Admin"
          description="User homepage for admin viewing details about company"
        />
      </Suspense>
      <UserDataAdminProvider userId={id}>
        {(user) => {
          return (
            <CompanyHomeContainer>
              <BreadCrumbs
                one="Admin Dashboard"
                oneLink="/admin"
                two="User Info"
              />
              <header>
                <h3>
                  {`${user?.firstName} ${user?.lastName}` ||
                    'Name is not available'}
                </h3>
              </header>
              <CompanyNav>
                <Link to={`/admin/edit-user/${id}`} className="nav-link">
                  Edit User
                </Link>
                |
                <Link to={`/admin/user/courses/${id}`} className="nav-link">
                  Courses
                </Link>
                |
                <Link
                  to={`/admin/user/purchase-history/${id}`}
                  className="nav-link"
                >
                  Purchase History
                </Link>
              </CompanyNav>
              <UserData user={user} />
            </CompanyHomeContainer>
          );
        }}
      </UserDataAdminProvider>
    </AuthCheckAdmin>
  );
};

export default UserAdminHome;
